document.addEventListener('DOMContentLoaded', () => {
  const isCartPage = window.location.href.includes('/cart');

  if (isCartPage) {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }, 3000);

    const targetNode = document.querySelector('cart-form');

    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      });

      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ['class'],
      });
    } else {
      console.warn('<cart-form> không tìm thấy trong DOM');
    }
  }
});
